import { Space } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import { BtnAnch } from 'components/elements/global'
import { TSSBlockList } from 'components/shared/Common'
import { MDataTableColumns } from 'components/shared/MDataTable/type'
import { TAlertStatus, TGetAlerts } from 'features/alert/types'
import { ReactNode } from 'react'

type TAlertProps = {
 handleControlAlert?: (id: any, status: TAlertStatus, name: string) => void
 handleClickEdit?: (data?: TGetAlerts) => void
}

const getCount = (val: number, onClick: () => void): ReactNode => {
 if ((val ?? 0) > 0) {
  return (
   <BtnAnch className="colored-link" onClick={onClick}>
    {val}
   </BtnAnch>
  )
 }
 return <a className="text-dark">{val}</a>
}

const AlertTableColumns = ({
 handleControlAlert,
 handleClickEdit,
}: TAlertProps): MDataTableColumns<TGetAlerts>[] => [
 {
  title: 'Name',
  dataIndex: 'name',
  size: 200,
 },
 {
  title: 'Active',
  dataIndex: 'active_count',
  size: 200,
  render: (val, r) =>
   getCount(val ?? 0, () => {
    handleControlAlert?.(r?.id, 'Active', r.name)
   }),
 },
 {
  title: 'Paused',
  dataIndex: 'paused_count',
  size: 200,
  render: (val, r) =>
   getCount(val ?? 0, () => handleControlAlert?.(r?.id, 'Pause', r.name)),
 },

 {
  title: 'Area',
  size: 200,
  render: (_e, r) => <div>{r?.area?.join?.(',')}</div>,
 },
 {
  title: 'Frequency',
  dataIndex: 'frequency',
  size: 200,
 },
 {
  title: 'Tags',
  dataIndex: 'tags',
  size: 200,
  render: (_e, r) => (
   <TSSBlockList typeId={r.id} mode="tag" type="alert" data={r.tags} closable />
  ),
 },
 {
  title: 'Stages',
  size: 200,
  render: (_e, r) => (
   <TSSBlockList
    typeId={r.id}
    mode="stage"
    type="alert"
    data={r.stages}
    closable
   />
  ),
 },
 {
  title: 'Source',
  size: 200,
  render: (_e, r) => (
   <TSSBlockList
    typeId={r.id}
    mode="source"
    type="alert"
    data={r.source}
    closable
   />
  ),
 },
 {
  title: 'Action',
  size: 70,
  fixed: 'right',
  render: (_, record) => (
   <Space>
    <BaseButton
     onClick={() => handleClickEdit?.(record)}
     tooltipText="Edit"
     shape="circle"
     size="small"
     buttonType="info"
     icon={<i className="fas fa-edit" />}
    />
   </Space>
  ),
 },
]

export default AlertTableColumns
